module.exports = __webpack_public_path__ + "static/media/upperleg.5a0b5b56.jpg";